import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { Link } from 'react-router-dom'
import FormInput from './FormInput'

const required = value => value ? undefined : 'Campo obrigatório'

class CampaignAddForm extends Component {
  render () {
    const { submitting, handleSubmit } = this.props
    return (
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <form className='form-horizontal' onSubmit={handleSubmit}>
              <div className='form-group'>
                <Field
                  type='text'
                  name='campaign_name'
                  component={FormInput}
                  label='Nome da Campanha:'
                  placeholder='nome da campanha'
                  validate={required}
                />
              </div>

              <div className='form-group'>
                <Field
                  type='text'
                  name='video_name'
                  component={FormInput}
                  label='Nome do Vídeo:'
                  placeholder='nome do video'
                  validate={required}
                />
              </div>

              <div className='form-group'>
                <div className='col-sm-9 col-sm-offset-2'>
                  <div className='pull-right'>
                    <Link to={`/campaigns`} className='btn btn-default'>Voltar</Link>
                    <button type='submit' className='btn btn-primary ml10' disabled={submitting}>Salvar</button>
                  </div>
                </div>
              </div>
  
              {/* <div className='form-group'>
                <Field
                  name='description'
                  component={FormTextarea}
                  label='Descrição:'
                  placeholder='breve descrição sobre a campanha'
                  validate={required}
                />
              </div>
    
              <div className='form-group'>
                <Field
                  type='text'
                  name='goal'
                  component={FormInput}
                  label='Objetivos:'
                  placeholder='objetivos e meta da campanha'
                  validate={required}
                />
              </div>
    
              <div className='form-group'>
                <Field
                  type='text'
                  name='audience'
                  component={FormInput}
                  label='Audiência:'
                  placeholder='especifique o target da campanha'
                  validate={required}
                />
              </div>
    
              <div className='form-group'>
                <Field
                  type='text'
                  name='media'
                  component={FormInput}
                  label='Estratégia de mídia:'
                  placeholder='como será feita a divulgação da campanha'
                  validate={required}
                />
              </div> */}
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export default reduxForm({ form: 'campaignAddForm' })(CampaignAddForm)



// WEBPACK FOOTER //
// ./src/components/CampaignAddForm.js